import { FormType, Languages, TripTypes } from '../../shared/models/form';
import { SearchData } from '../../shared/models/v1/ApiModel';
import { th, enGB, zhCN } from 'date-fns/locale';

export function getSearchFormData(formData: FormType, language: Languages): SearchData {
  const bounds = formData.bounds
    .map(({ origin, destination, departure }) => {
      if (origin && destination && departure) {
        return { origin: origin.value, destination: destination.value, date: departure };
      }
      return { origin: '', destination: '', date: '' };
    })
    .filter((bound) => bound.origin !== '');

  if (formData.tripType === TripTypes.roundTrip) {
    const firstBound = formData.bounds[0];
    const returnBound = {
      origin: firstBound.destination?.value ?? '',
      destination: firstBound.origin?.value ?? '',
      date: firstBound.return ?? '',
    };

    if (returnBound.origin && returnBound.destination && returnBound.date) {
      bounds.push(returnBound);
    }
  }

  return {
    adults: formData.adults,
    childAges: formData.childrenAges?.map(({ age }) => age) ?? [],
    infantAges: formData.infantsAges?.map(({ age }) => age) ?? [],
    promoCode: formData.promoCode,
    language: language,
    currency: formData.currency,
    bounds: bounds,
    lowestFare: formData.lowestFare,
    tripType: formData.tripType,
  };
}

export function getLanguage(): Languages {
  const lang = new URLSearchParams(window.location.search).get('lang');
  if (lang === Languages.thai || lang === Languages.chinese) {
    return lang;
  }
  return Languages.english;
}

export const getLocale = (): Locale => {
  switch (getLanguage()) {
    case Languages.thai:
      return th;
    case Languages.chinese:
      return zhCN;
    default:
      return enGB;
  }
};
